import { defineEvent } from "@otto-ec/global-resources/nexus"
import type { CustomerSessionRefreshed } from "../nexus.ts"

otto.customerSession.assignNamespace({
    onCustomerSessionRefresh: defineEvent(),
})
let sessionRefreshedChannel: BroadcastChannel | null = null
if ("BroadcastChannel" in window) {
    sessionRefreshedChannel = new BroadcastChannel("fti-session-refreshed")
    sessionRefreshedChannel.onmessage = (event: MessageEvent<CustomerSessionRefreshed>) => {
        otto.customerSession.onCustomerSessionRefresh.set(event.data)
    }
}
export function publishCustomerSessionRefreshed(customerSessionRefreshed: CustomerSessionRefreshed) {
    otto.customerSession.onCustomerSessionRefresh.set(customerSessionRefreshed)
    sessionRefreshedChannel?.postMessage(customerSessionRefreshed)
}
